import { render, staticRenderFns } from "./TelehealthConsent.vue?vue&type=template&id=363a63fe&scoped=true"
import script from "./TelehealthConsent.vue?vue&type=script&lang=js"
export * from "./TelehealthConsent.vue?vue&type=script&lang=js"
import style0 from "./TelehealthConsent.vue?vue&type=style&index=0&id=363a63fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363a63fe",
  null
  
)

export default component.exports